import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* Original name @uswitch/trustyle.input-alert */
import * as React from 'react';
import { useThemeUI } from 'theme-ui';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
var ARROW_SIZE = 8;
export var InputAlert = function InputAlert(_ref) {
  var _theme$elements, _theme$elements$input, _theme$elements2, _theme$elements2$inpu, _theme$elements3, _theme$elements3$inpu;

  var type = _ref.type,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var padding = theme === null || theme === void 0 ? void 0 : (_theme$elements = theme.elements) === null || _theme$elements === void 0 ? void 0 : (_theme$elements$input = _theme$elements['input-alert']) === null || _theme$elements$input === void 0 ? void 0 : _theme$elements$input.padding;
  var notificationColor = theme === null || theme === void 0 ? void 0 : (_theme$elements2 = theme.elements) === null || _theme$elements2 === void 0 ? void 0 : (_theme$elements2$inpu = _theme$elements2['input-alert']) === null || _theme$elements2$inpu === void 0 ? void 0 : _theme$elements2$inpu.notificationColor;
  var alertColor = theme === null || theme === void 0 ? void 0 : (_theme$elements3 = theme.elements) === null || _theme$elements3 === void 0 ? void 0 : (_theme$elements3$inpu = _theme$elements3['input-alert']) === null || _theme$elements3$inpu === void 0 ? void 0 : _theme$elements3$inpu.alertColor;
  return _jsx("div", _objectSpread(_objectSpread({}, props), {}, {
    sx: {
      variant: 'elements.input-alert',
      marginTop: "calc(".concat(ARROW_SIZE, "px + ").concat(padding, "px)"),
      backgroundColor: type === 'alert' ? alertColor : notificationColor,
      '&:before': {
        variant: 'elements.input-alert.before',
        top: -ARROW_SIZE,
        borderLeft: "".concat(ARROW_SIZE, "px solid transparent"),
        borderRight: "".concat(ARROW_SIZE, "px solid transparent"),
        borderBottomWidth: ARROW_SIZE,
        borderBottomColor: type === 'alert' ? alertColor : notificationColor
      }
    },
    children: children
  }));
};
export default InputAlert;
//# sourceMappingURL=index.js.map